import { Button } from "@/components/ui/button";
import { MessageCircle } from "lucide-react";
import { useCrispChat } from "@/hooks/useCrispChat";

interface ChatButtonProps {
  className?: string;
  variant?: "default" | "destructive" | "outline" | "secondary" | "ghost" | "link";
  size?: "default" | "sm" | "lg" | "icon";
  children?: React.ReactNode;
}

export const ChatButton: React.FC<ChatButtonProps> = ({
  className = "",
  variant = "default",
  size = "default",
  children
}) => {
  const { openChat, isReady } = useCrispChat();

  return (
    <Button
      onClick={openChat}
      variant={variant}
      size={size}
      className={className}
      disabled={!isReady}
    >
      <MessageCircle className="w-4 h-4 mr-2" />
      {children || "Chat with us"}
    </Button>
  );
};

export default ChatButton;
